import type { Translation } from '../../types';
import type { operator as en } from '../en/operator';

export const operator: Translation<typeof en> = {
  common: {
    reason: 'Lý do',
    reasonHint: 'Được ghi vào nhật ký kiểm toán cùng tên của bạn.',
    close: 'Đóng',
    cancel: 'Huỷ',
    choose: 'Chọn…',
    loading: 'Đang tải…',
    optional: 'không bắt buộc',
    now: 'Ngay bây giờ',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    done: 'Đã xong.',
    showOnce: 'Chỉ hiển thị một lần này. Hãy sao chép ngay: sau khi đóng sẽ không xem lại được.',
  },

  transferIn: {
    button: 'Chuyển tên miền về',
    title: 'Chuyển tên miền về cho khách hàng',
    description: 'Tên miền đang ở nhà đăng ký khác: báo giá trên tài khoản khách hàng, chọn chủ thể đứng tên, nhập mã chuyển; đơn hàng giữ tiền cho tới khi registry hoàn tất.',
    customer: 'Khách hàng',
    domain: 'Tên miền',
    domainHint: 'Tên miền đang đăng ký ở nhà đăng ký khác.',
    price: 'Báo giá',
    quote: '{{domain}}: {{total}} · trừ vào tài khoản {{customer}}',
    registrant: 'Chủ thể đứng tên',
    registrantHint: 'Một chủ thể của khách hàng, đủ thông tin theo quy định (kiểm tra trước khi giữ tiền).',
    noRegistrant: 'Khách hàng chưa có chủ thể nào: thêm chủ thể trước.',
    authInfo: 'Mã chuyển tên miền',
    authInfoHint: 'Mã do nhà đăng ký hiện tại cấp cho chủ thể; chỉ gửi một lần, không hiển thị lại.',
    submit: 'Đặt chuyển về',
    started: 'Đã đặt chuyển tên miền về; tiến trình hiện trên trang tên miền.',
  },
  register: {
    button: 'Đăng ký tên miền',
    title: 'Đăng ký tên miền cho khách hàng',
    description:
      'Đơn hàng được đặt trên tài khoản của khách hàng và trừ vào số dư của họ, giống hệt như khách tự đặt. Hệ thống gửi yêu cầu đến nhà đăng ký (registry) ngay.',
    customer: 'Khách hàng',
    customerSearch: 'Tên hoặc e-mail của khách hàng',
    customerNone: 'Không tìm thấy khách hàng',
    domain: 'Tên miền',
    domainHint: 'Ví dụ tenmien.vn',
    years: 'Thời hạn',
    yearsN_one: '{{count}} năm',
    yearsN_other: '{{count}} năm',
    promotion: 'Mã khuyến mãi',
    vnnicPromo: {
      title: 'Chương trình đăng ký miễn phí của VNNIC',
      chooseRegistrant: 'Chọn chủ thể đăng ký bên dưới để kiểm tra chủ thể có được miễn phí không.',
      request: 'Xin mã khuyến mãi VNNIC',
      recheck: 'Kiểm tra lại',
      issued: 'Chủ thể đủ điều kiện. Mã {{code}} còn hiệu lực đến {{until}} (còn {{left}}).',
      expired: 'Mã {{code}} đã hết hạn lúc {{until}}. Kiểm tra lại trước khi áp dụng chương trình miễn phí.',
      reused: '(kết quả kiểm tra trước đó, vẫn còn hiệu lực)',
      newCodeNote: 'Mỗi lần đăng ký, hệ thống xin VNNIC một mã mới ngay trước khi tạo tên miền; mã này chỉ để xác nhận chủ thể đủ điều kiện và báo giá.',
      refusedReason: 'Lý do của VNNIC:',
      apply: 'Áp dụng chương trình miễn phí',
      applied_one: 'Đã áp dụng: miễn lệ phí, phí duy trì và phí dịch vụ, tối đa {{count}} năm.',
      applied_other: 'Đã áp dụng: miễn lệ phí, phí duy trì và phí dịch vụ, tối đa {{count}} năm.',
      missingTitle: 'Hồ sơ chủ thể còn thiếu thông tin',
      missingBody: 'Bổ sung các mục sau trong hồ sơ chủ thể rồi xin mã lại:',
      openSubject: 'Mở hồ sơ chủ thể',
      refused: 'VNNIC không cấp mã khuyến mãi cho chủ thể này',
      fields: {
        legal_name: 'Họ tên / tên tổ chức',
        address: 'Địa chỉ tại Việt Nam (tỉnh/thành phố và phường/xã)',
        province: 'Tỉnh/thành phố (theo danh mục hành chính)',
        ward: 'Phường/xã (theo danh mục hành chính, thuộc tỉnh/thành phố đã chọn)',
        street: 'Số nhà, đường',
        identifier: 'Số CCCD / hộ chiếu hoặc mã số doanh nghiệp',
        birth_date: 'Ngày sinh',
        gender: 'Giới tính',
        establish_date: 'Ngày thành lập',
        household_code: 'Mã số đăng ký hộ kinh doanh',
        owner_name: 'Họ tên chủ hộ kinh doanh',
      },
    },
    check: 'Kiểm tra và báo giá',
    available: '{{name}} còn trống, có thể đăng ký.',
    unavailable: 'Không thể đăng ký {{name}}: {{reason}}',
    unknown: 'Hiện chưa hỏi được nhà đăng ký. Vui lòng thử lại sau ít phút.',
    registryProblem: 'Giá đã tính, nhưng kết nối registry của TLD này chưa dùng được nên chưa đặt đăng ký được.',
    reasons: {
      INVALID_NAME: 'đây không phải là tên miền hợp lệ',
      TLD_NOT_SUPPORTED: 'chúng ta không bán đuôi tên miền này',
      REGISTRY_UNAVAILABLE: 'nhà đăng ký không phản hồi',
      REGISTRY_NOT_CONFIGURED: 'kết nối registry của TLD này chưa dùng được',
      REGISTRY_AUTH_FAILED: 'nhà đăng ký từ chối đăng nhập',
      REGISTRY_ERROR: 'nhà đăng ký báo lỗi',
      REGISTRY_TIMEOUT: 'nhà đăng ký không trả lời kịp',
      TLD_NOT_OFFERED_BY_REGISTRY: 'nhà đăng ký không cung cấp đuôi tên miền này',
      taken: 'tên miền đã có người đăng ký',
    },
    price: 'Giá cho {{years}}: {{total}} đã gồm thuế (có hiệu lực đến {{until}}).',
    discount: 'Giảm giá từ mã khuyến mãi: {{amount}}.',
    addonLine: 'phí / dịch vụ kèm theo TLD · {{tax}}',
    registrant: 'Chủ thể đăng ký',
    registrantHint: 'Cá nhân hoặc tổ chức sẽ là chủ sở hữu tên miền. Chỉ liệt kê chủ thể của khách hàng này.',
    noRegistrant: 'Khách hàng này chưa có chủ thể nào. Hãy tạo chủ thể ở trang khách hàng trước.',
    nameservers: 'Máy chủ tên miền (DNS)',
    nameserversHint: 'Mỗi dòng một máy chủ. Để trống để dùng máy chủ mặc định.',
    agreement: 'Thoả thuận đăng ký đã chấp nhận',
    agreementHint: 'Phiên bản thoả thuận đăng ký tên miền mà chủ thể đã chấp nhận, ví dụ 2026-01.',
    submit: 'Đặt đơn và đăng ký',
    placed: 'Đã đặt đơn. {{name}} đang được đăng ký; trang tên miền hiển thị tiến trình.',
    openDomain: 'Mở trang tên miền',
  },

  access: {
    kind: {
      CREATE_STAFF: 'Thêm nhân viên',
      DISABLE_STAFF: 'Vô hiệu hoá tài khoản',
      ENABLE_STAFF: 'Mở lại tài khoản',
      RESET_MFA: 'Đặt lại ứng dụng xác thực',
      UNLOCK_STAFF: 'Mở khoá đăng nhập',
      GRANT_ROLE: 'Cấp vai trò',
      REVOKE_ROLE: 'Thu hồi vai trò',
      ISSUE_API_CREDENTIAL: 'Cấp khoá API',
      CHANGE_REPORTING_CONSUMER: 'Sửa dữ liệu nơi nhận được nhận',
      ISSUE_REPORTING_KEY: 'Tạo khoá API báo cáo',
      ROTATE_REPORTING_KEY: 'Đổi khoá API báo cáo',
      RESET_REPORTING_SYNC: 'Đồng bộ lại từ đầu',
    },
    status: {
      PENDING: 'Đang chờ duyệt',
      APPROVED: 'Đã duyệt, chưa thực hiện',
      REJECTED: 'Bị từ chối',
      EXPIRED: 'Đã hết hạn',
      EXECUTED: 'Đã thực hiện',
      CANCELLED: 'Đã rút lại',
    },
    pendingTitle: 'Thay đổi quyền truy cập đang chờ',
    pendingHint: 'Mọi thay đổi về quyền của nhân viên hoặc khoá API đều cần được duyệt thêm một lần trước khi thực hiện.',
    none: 'Không có gì đang chờ.',
    requestedBy: '{{name}} đề nghị',
    decidedBy: '{{name}} quyết định',
    selfApproved: 'Chính người đề nghị đã duyệt bằng mã xác thực của mình.',
    target: 'Áp dụng cho',
    proposed: 'Đề nghị đã được ghi nhận. Thay đổi sẽ được thực hiện sau khi được duyệt.',
    selfApproveTitle: 'Tự duyệt thay đổi của bạn',
    selfApproveHint:
      'Bạn được tự duyệt đề nghị của chính mình khi không có người khác duyệt. Nhập mã 6 số hiện tại trong ứng dụng xác thực để xác nhận đúng là bạn.',
    waitSecond: 'Cần một người khác có quyền quản lý nhân viên duyệt. Họ sẽ thấy đề nghị trong mục Phê duyệt.',
    openApprovals: 'Mở mục Phê duyệt',
    totp: 'Mã xác thực',
    approveApply: 'Duyệt và thực hiện',
    approve: 'Đồng ý',
    reject: 'Từ chối',
    decisionReason: 'Lý do đồng ý hoặc từ chối',
    apply: 'Thực hiện',
    applyTitle: 'Thực hiện thay đổi đã được duyệt',
    withdraw: 'Rút lại',
    withdrawReason: 'Lý do rút lại',
    applied: 'Đã thực hiện.',
    password: 'Mật khẩu đầu tiên',
    passwordHint: 'Ít nhất 12 ký tự. Để trống thì hệ thống tự tạo.',
    totpUri: 'Liên kết cài đặt ứng dụng xác thực',
    totpUriHint:
      'Gửi riêng cho người đó: họ thêm liên kết này vào ứng dụng xác thực (dán vào, hoặc chuyển thành mã QR). Đây là cách duy nhất để đăng nhập.',
    initialPassword: 'Mật khẩu đầu tiên',
    apiKey: 'Khoá API',
    apiKeyHint: 'Gửi riêng cho khách hàng. Hệ thống chỉ lưu dấu vân tay của khoá, không lưu khoá.',
    newStaff: 'Thêm nhân viên',
    newStaffDescription: 'Tài khoản được tạo sau khi đề nghị được duyệt. Bạn sẽ nhận thông tin đăng nhập để bàn giao.',
    email: 'Địa chỉ e-mail',
    displayName: 'Họ và tên',
    roles: 'Vai trò',
    rolesHint: 'Áp dụng cho toàn bộ nền tảng. Có thể thêm vai trò giới hạn trong một khách hàng sau.',
    actions: 'Thay đổi quyền',
    disable: 'Vô hiệu hoá tài khoản',
    disableHint: 'Người đó bị đăng xuất ở mọi nơi và không thể đăng nhập nữa.',
    enable: 'Mở lại tài khoản',
    resetMfa: 'Đặt lại ứng dụng xác thực',
    resetMfaHint: 'Khi mất hoặc đổi điện thoại. Người đó bị đăng xuất và nhận liên kết cài đặt mới.',
    unlock: 'Mở khoá đăng nhập',
    unlockHint: 'Nhập sai mật khẩu quá nhiều lần thì tài khoản bị khoá một thời gian. Thao tác này mở khoá ngay.',
    grantRole: 'Cấp vai trò',
    revokeRole: 'Thu hồi vai trò',
    role: 'Vai trò',
    scope: 'Phạm vi',
    scopeGlobal: 'Toàn bộ nền tảng',
    scopeCustomer: 'Một khách hàng',
    scopeAccount: 'Tài khoản',
    submitProposal: 'Gửi đề nghị',
  },

  keys: {
    issue: 'Cấp khoá API',
    issueDescription:
      'Khách hàng dùng khoá để làm việc với chúng ta từ hệ thống của mình (đặt mua, gia hạn, quản lý tên miền). Khoá được tạo sau khi đề nghị được duyệt và chỉ hiển thị một lần.',
    owner: 'Tài khoản',
    ownerSearch: 'Tên tài khoản',
    expires: 'Hiệu lực đến',
    expiresHint: 'Để trống nếu không giới hạn thời gian.',
    revoke: 'Thu hồi',
    revokeTitle: 'Thu hồi khoá API này',
    revokeDescription: 'Khoá ngừng hoạt động ngay. Các chương trình đang dùng khoá sẽ bị từ chối cho đến khi dùng khoá mới.',
    revoked: 'Đã thu hồi khoá.',
  },

  tax: {
    new: 'Thuế suất mới',
    newVersion: 'Phiên bản mới',
    description:
      'Thuế suất GTGT của một mã thuế (ví dụ VAT10 = 10%). Phiên bản mới bắt đầu từ thời điểm bạn chọn và thay phiên bản đang áp dụng lúc đó; báo giá đã gửi khách giữ thuế suất cũ. Mỗi sản phẩm chọn mã thuế của mình; giá tên miền và add-on không ghi mã thì dùng mã mặc định.',
    code: 'Mã thuế',
    codeHint: 'Chữ in hoa và số, ví dụ VAT10. KCT (không chịu thuế) là loại thuế, không phải mã.',
    percent: 'Thuế suất (%)',
    source: 'Căn cứ pháp lý',
    sourceHint: 'Văn bản quy định thuế suất, ví dụ Luật Thuế GTGT 48/2024/QH15.',
    publish: 'Công bố thuế suất',
    endTitle: 'Kết thúc thuế suất',
    endDescription: 'Từ thời điểm kết thúc, sản phẩm dùng mã thuế này không được báo giá cho tới khi có phiên bản mới hoặc đổi sang mã khác.',
    makeDefault: 'Đặt làm mặc định',
    defaultDescription: 'Giá tên miền và add-on không ghi mã thuế sẽ tính theo {{code}}. Báo giá đã gửi khách không đổi.',
    defaultSet: 'Mã thuế mặc định giờ là {{code}}.',
  },
  pricing: {
    newCost: 'Giá vốn mới',
    newCostDescription:
      'Số tiền nhà đăng ký (registry) thu của chúng ta. Giá mới bắt đầu từ thời điểm bạn chọn và thay giá đang áp dụng lúc đó; các báo giá đã gửi khách không thay đổi. Giá vốn gắn với TLD, không gắn với kết nối hay môi trường (OT&E / production): khi TLD chuyển sang registry khác với giá khác, hãy tạo phiên bản giá mới cho TLD.',
    costGrid: {
      description: 'Giá vốn registry của TLD cho mọi nghiệp vụ trong một lần nhập; để trống = giữ nguyên. Giá mới bắt đầu từ thời điểm chọn và thay giá đang áp dụng; báo giá đã gửi khách không đổi.',
      years: 'Thời hạn',
      yearsValue_one: '{{count}} năm',
      yearsValue_other: '{{count}} năm',
      all: 'Áp dụng cho tất cả nghiệp vụ',
      apply: 'Áp dụng',
      op: 'Nghiệp vụ',
      current: 'Giá vốn hiện tại',
      amount: 'Giá vốn mới',
      converted: 'Quy đổi (VND)',
      keep: 'Giữ nguyên',
      none: 'Chưa có',
      since: 'từ {{date}} · v{{version}}',
      noFx: 'Chưa có tỷ giá',
      save_one: 'Lưu {{count}} nghiệp vụ',
      save_other: 'Lưu {{count}} nghiệp vụ',
      nothing: 'Chưa có nghiệp vụ nào thay đổi.',
      saved_one: 'Đã lưu giá vốn cho {{count}} nghiệp vụ.',
      saved_other: 'Đã lưu giá vốn cho {{count}} nghiệp vụ.',
      pickFirst: 'Chọn TLD để nhập giá vốn cho mọi nghiệp vụ.',
    },
    registry: 'Nhà đăng ký',
    tld: 'Đuôi tên miền',
    anyTld: 'Mọi đuôi tên miền',
    operation: 'Thao tác',
    years: 'Số năm',
    anyYears: 'Mọi thời hạn (giá theo năm)',
    amount: 'Số tiền',
    currency: 'Tiền tệ',
    from: 'Bắt đầu',
    fromHint: 'Để trống để bắt đầu ngay. Giá không bao giờ bắt đầu trong quá khứ.',
    until: 'Kết thúc',
    untilHint: 'Để trống để kết thúc ngay.',
    end: 'Kết thúc',
    endTitle: 'Kết thúc mức giá này',
    endDescription: 'Sau thời điểm kết thúc, mức giá này không còn dùng cho báo giá mới. Các báo giá đã gửi giữ nguyên giá.',
    published: 'Đã áp dụng, phiên bản {{version}}.',
    newBook: 'Bảng giá mới',
    newBookDescription:
      'Bảng giá quy định giá bán cho một nhóm khách hàng. Bảng giá mới ở trạng thái nháp: chưa báo giá cho khách nào cho đến khi bạn kích hoạt.',
    code: 'Mã',
    appliesTo: 'Dùng cho',
    tier: 'Hạng khách hàng',
    tierHint: 'Một hạng trong danh mục: bảng giá của hạng định giá mọi sản phẩm cho khách thuộc hạng đó.',
    customer: 'Khách hàng',
    status: 'Trạng thái',
    setStatus: 'Đổi trạng thái',
    activate: 'Kích hoạt',
    retire: 'Ngừng dùng',
    statusTitle: 'Đổi trạng thái bảng giá',
    statusDraft: 'Nháp',
    statusActive: 'Đang dùng',
    statusRetired: 'Ngừng dùng',
    retiredForever: 'Bảng giá đã ngừng dùng thì không thể dùng lại.',
    newRule: 'Giá bán mới',
    newRuleDescription:
      'Phiên bản mới của giá bán cho thao tác và đuôi tên miền này. Giá mới thay giá đang áp dụng kể từ lúc bắt đầu; các báo giá đã gửi giữ nguyên giá.',
    ruleType: 'Cách tính giá',
    value: 'Giá trị',
    valueHint: 'Một mức giá cố định, một khoản cộng thêm vào giá vốn, hoặc phần trăm cộng thêm vào giá vốn.',
    min: 'Giá thấp nhất',
    max: 'Giá cao nhất',
    priority: 'Thứ tự ưu tiên',
    priorityHint: 'Khi có nhiều mức giá cùng áp dụng, số nhỏ hơn được dùng.',
    ruleTypes: {
      FIXED_PRICE: 'Giá cố định',
      MARKUP_FIXED: 'Giá vốn cộng một khoản',
      MARKUP_PERCENT: 'Giá vốn cộng phần trăm',
    },
    appliesToValues: {
      TIER: 'Mọi khách hàng của một hạng',
      CUSTOMER_CONTRACT: 'Một khách hàng (giá riêng cho một vài sản phẩm)',
    },
    operations: {
      REGISTER: 'Đăng ký mới',
      RENEW: 'Gia hạn',
      TRANSFER: 'Chuyển về',
      RESTORE: 'Khôi phục',
      REDEMPTION: 'Chuộc lại',
      BACKORDER: 'Đặt trước',
      AUCTION: 'Đấu giá',
      ADDON: 'Dịch vụ thêm',
    },
    addon: 'Dịch vụ thêm',
    book: 'Bảng giá',
    forOperation: 'Áp dụng cho nghiệp vụ',
    forOperationHint: 'Giá riêng cho một nghiệp vụ (ví dụ phí khi đăng ký khác khi gia hạn); để "mọi nghiệp vụ" nếu như nhau.',
    everyOperation: 'Mọi nghiệp vụ của dịch vụ',
    amountBasis: 'Cách tính',
    amountBases: { FIXED: 'Số tiền cố định', PERCENT_OF_REGISTRY_COST: '% giá vốn của nghiệp vụ' },
    amountBasisHint: {
      FIXED: 'Số tiền cho 1 năm (dịch vụ tính theo năm được nhân số năm của nghiệp vụ) hoặc cho 1 lần.',
      PERCENT_OF_REGISTRY_COST: 'Phần trăm giá vốn registry của nghiệp vụ đi kèm (đã gồm số năm), ví dụ 2 %.',
    },
    percent: 'Phần trăm (%)',
    addonYearsHint: 'Thường là 1: giá cho một năm.',
    alsoTlds: 'Đặt cùng giá cho các TLD khác',
    alsoTldsHint: 'Mỗi TLD được chọn có một dòng giá riêng (không có giá chung cho mọi TLD).',
    addonCostDescription:
      'Giá của dịch vụ cho TLD này (phí thu hộ hoặc giá vốn). Không có giá bán trong bảng giá thì khách trả đúng số tiền này. Giá mới thay giá đang áp dụng từ lúc bắt đầu; báo giá đã gửi giữ nguyên.',
    addonPerTld: 'Giá dịch vụ đặt riêng cho từng TLD.',
    addonElsewhere: 'Giá phí và dịch vụ thêm đặt ở trang TLD, tab Giá & dịch vụ.',
    taxCategory: 'Loại thuế',
    taxCode: 'Mã thuế suất VAT',
    taxCodeHint: 'Để trống = thuế suất VAT mặc định.',
    taxCategories: { VAT: 'VAT', KCT: 'Không chịu thuế (KCT)' },
  },

  promotions: {
    create: 'Khuyến mãi mới',
    createDescription: 'Mã khách nhập để được giảm giá. Các báo giá đã gửi giữ nguyên giá.',
    edit: 'Sửa',
    editDescription: 'Khi mã đã được dùng, chỉ có thể đổi ngày kết thúc và số lần dùng tối đa.',
    disable: 'Tắt mã',
    disableTitle: 'Tắt mã khuyến mãi này',
    disableDescription: 'Mã ngừng giảm giá cho báo giá mới ngay. Các báo giá đã gửi vẫn giữ mức giảm.',
    disabled: 'Đã tắt',
    disabledOn: 'Đã tắt {{when}}: {{reason}}',
    code: 'Mã',
    codeHint: 'Chữ, số, - hoặc _. Được lưu dạng chữ in hoa.',
    discountType: 'Kiểu giảm',
    percent: 'Phần trăm',
    fixed: 'Số tiền cố định',
    value: 'Giá trị',
    currency: 'Tiền tệ',
    tld: 'Đuôi tên miền',
    anyTld: 'Mọi đuôi tên miền',
    operation: 'Thao tác',
    anyOperation: 'Mọi thao tác',
    starts: 'Bắt đầu',
    ends: 'Kết thúc',
    maxUses: 'Số lần dùng tối đa',
    maxUsesHint: 'Để trống nếu không giới hạn.',
    saved: 'Đã lưu.',
    created: 'Đã tạo mã khuyến mãi {{code}}.',
  },

  registry: {
    resolve: 'Xử lý',
    resolveTitle: 'Xử lý chênh lệch này',
    resolveDescription: 'Ghi lại bạn đã kiểm tra thấy gì và đã làm gì. Chênh lệch được đóng lại, nhật ký kiểm toán giữ lời giải thích của bạn.',
    outcome: 'Kết quả kiểm tra',
    outcomes: {
      REGISTRY_CORRECT: 'Nhà đăng ký đúng: cập nhật dữ liệu của chúng ta theo nhà đăng ký',
      FIXED: 'Đã sửa thủ công (tại nhà đăng ký hoặc tại đây)',
      NO_ACTION: 'Không cần làm gì: báo nhầm hoặc chênh lệch được chấp nhận',
    },
    commandStays: 'Lệnh gửi nhà đăng ký gắn với chênh lệch này giữ nguyên trạng thái; thao tác này chỉ ghi lại kết luận của bạn.',
    resolved: 'Đã xử lý.',
    resolvedBy: '{{name}} đã xử lý {{when}}',
    ack: 'Xác nhận với nhà đăng ký',
    ackTitle: 'Xác nhận thông báo này với nhà đăng ký',
    ackDescription: 'Nhà đăng ký giữ thông báo trong hàng đợi cho đến khi chúng ta xác nhận đã nhận. Dùng khi lần xác nhận trước không đến được nhà đăng ký.',
    acked: 'Nhà đăng ký đã nhận xác nhận.',
    processed: 'Đánh dấu đã xử lý',
    processedTitle: 'Đánh dấu thông báo này đã xử lý',
    processedDescription: 'Ghi lại việc đã làm với thông báo này.',
    markedProcessed: 'Đã đánh dấu là đã xử lý.',
  },

  market: {
    cancelBackorder: 'Huỷ đặt giữ tên miền',
    cancelBackorderDescription: 'Chỉ huỷ được yêu cầu đặt giữ tên miền chưa được lên kế hoạch cho đợt tên miền hết hạn. Số tiền đang giữ được trả lại cho khách.',
    backorderCancelled: 'Đã huỷ đặt giữ tên miền và trả lại số tiền đang giữ.',
    open: 'Mở phiên ngay',
    openTitle: 'Mở phiên đấu giá ngay',
    openDescription: 'Dùng khi phiên mở muộn. Phiên đấu giá không bao giờ mở trước giờ bắt đầu đã công bố.',
    close: 'Đóng phiên ngay',
    closeTitle: 'Đóng phiên đấu giá ngay',
    closeDescription:
      'Dùng khi phiên đóng muộn. Giá cao nhất thắng nếu đạt giá sàn. Phiên đấu giá không bao giờ đóng trước giờ kết thúc đã công bố.',
    opened: 'Phiên đấu giá đã mở.',
    closed: 'Phiên đấu giá đã đóng: {{status}}.',
  },
};
